export const AxiosErrorCodes = {
  ECONNABORTED: 'ECONNABORTED',
  ETIMEDOUT: 'ETIMEDOUT',
} as const;

export type AxiosErrorCodes =
  (typeof AxiosErrorCodes)[keyof typeof AxiosErrorCodes];
